export const hasPurchaseIntentionTool = (tools = []) => (
  tools.some((tool) => (tool?.name || tool?.id) === 'purchase_intention')
);

export const purchaseIntentionArgs = (aiDisabled = true) => (
  [{ ai_disabled: aiDisabled !== false }]
);

export const readAiDisabledFromToolArgs = (args) => {
  const args0 = args?.[0] || {};
  return args0.ai_disabled !== false;
};
